export default "//cloud.imgsmail.ru/cloud.mail.ru/185028/img/build/empty-state/shared-incoming.png";